<app-loading
  [loading]="loading"
>
</app-loading>
<div class="row">
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div *ngIf="telaPequena" style="margin-top: -30px;font-size: 15px" class="col-md-12 titulo-dia text-center">
          <span class="fa fa-chevron-left" (click)="diminuirDia()"></span>
          {{diaTexto}} - {{mesTexto}}
          <span class="fa fa-chevron-right" (click)="adicionarDia()"></span>
        </div>
        <div *ngIf="!telaPequena" class="titulo-dia col-md-6">
          <span class="fa fa-chevron-left troca-dia" (click)="diminuirDia()"></span>
          Dia {{diaTexto}}
          <span class="fa fa-chevron-right troca-dia" (click)="adicionarDia()"></span>
        </div>
        <div *ngIf="!telaPequena" class="titulo-mes col-md-6">{{ mesTexto }} - 2024</div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="lista.itemHoras.length > 0">
    <div class="col-md-12 col-sm-12 linha-horario linha-horario-cor" *ngFor="let item of lista.itemHoras; let i = index" [ngClass]="{'linha-horario-cor': i % 2 == 0}">
      <span><i class="fa fa-clock-o"></i> {{item.hora}}:00</span>
    </div>
  </div>
  <div class="row" *ngIf="lista.itemHoras.length <= 0">
    <div  class="col-md-12 col-sm-12 linha-horario linha-horario-cor">
      <div class="row">
        <div class="col-md-12 titulo-sem-compromisso text-center">Não existe nenhum compromisso agendado para hoje</div>
      </div>
    </div>
  </div>
</div>
